export default `import React from 'react';
import ReactDOM from 'react-dom';
import { Button } from 'zapify-ui';
            
ReactDOM.render(
    <Button className="primaryButton">Hello World</Button>,
    document.getElementById('app')
);`;